var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('a',{attrs:{"href":_vm.fbAuthURL}},[_vm._v("Facebook")]),_c('a',{attrs:{"href":_vm.googleAuthURL}},[_vm._v("Google")])])
}
var staticRenderFns = []

export { render, staticRenderFns }